<template>
    <div>
        <div class="columns">
            <div class="column is-5">
                <form-group type="number"
                            label="Account Number"
                            id="account_number"
                            v-model="form.account_number"
                            :error="form.errors.get('account_number')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="First Name"
                            id="first_name"
                            v-model="form.first_name"
                            :error="form.errors.get('first_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Last Name"
                            id="last_name"
                            v-model="form.last_name"
                            :error="form.errors.get('last_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="email"
                            label="Email"
                            id="email"
                            v-model="form.email"
                            :error="form.errors.get('email')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="tel"
                            label="Phone"
                            id="phone"
                            v-model="form.phone"
                            :error="form.errors.get('phone')"
                            @event="form.listen(form, $event)">
                </form-group>

                <a v-if="!create" @click="toggleSetPassword()">
                    {{ setPassword ? 'Don\'t change password' : 'Change Password' }}
                </a>
                <span v-if="setPassword || create">
                    <form-group type="text"
                                label="Password"
                                id="password"
                                v-model="form.password"
                                :error="form.errors.get('password')"
                                @event="form.listen(form, $event)">
                    </form-group>

                    <form-group type="text"
                                label="Confirm Password"
                                id="password_confirmation"
                                v-model="form.password_confirmation"
                                :error="form.errors.get('password_confirmation')"
                                @event="form.listen(form, $event)">
                    </form-group>
                </span>

            </div>
            <div class="column is-7">

                <form-group type="text"
                            label="Address Line 1"
                            id="line1"
                            v-model="form.line1"
                            :error="form.errors.get('line1')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Address Line 2"
                            id="line2"
                            v-model="form.line2"
                            :error="form.errors.get('line2')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Address Line 3"
                            id="line3"
                            v-model="form.line3"
                            :error="form.errors.get('line3')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="City"
                            id="city"
                            v-model="form.city"
                            :error="form.errors.get('city')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="states"
                            label="State"
                            id="state"
                            v-model="form.state"
                            :error="form.errors.get('state')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Zip"
                            id="zip"
                            v-model="form.zip"
                            :error="form.errors.get('zip')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Country"
                            id="country"
                            v-model="form.country"
                            :error="form.errors.get('country')"
                            @event="form.listen(form, $event)">
                </form-group>
            </div>
        </div>
        <div class="has-text-centered">
            <button type="button" class="button is-primary" @click="submit()">{{ create ? 'Create User' : 'Save Changes' }}</button>
        </div>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {CREATE_USER, UPDATE_USER} from "../../store/mutation-types"
    export default {
        props: {
            user: {
                type: [String, Object], default: () => {
                    return {
                        account_number: '',
                        first_name: '',
                        last_name: '',
                        phone: '',
                        email: '',
                        line1: '',
                        line2: '',
                        line3: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',
                        timezone: '',
                    }
                }
            },
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                setPassword: false,
                form: new Form(this, Object.assign({}, this.user, {
                    password: null,
                    password_confirmation: null,
                }), this.create ? CREATE_USER : UPDATE_USER)
            }
        },
        methods: {
            submit() {
                this.form.submit().then(data => {
                    this.$emit('saved', data)
                })
            },
            toggleSetPassword() {
                this.setPassword = !this.setPassword
                if (!this.setPassword) {
                    this.form.password              = null
                    this.form.password_confirmation = null
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// UserForm.vue?3d70f02a